import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiagramProject, faAngleDoubleUp, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

import { SubHeading } from '../../../components';
import { images } from '../../../constants';
import './LexiLensAIHeader.css';
import '../Header.css';

const LexiLensAIHeader = () => {
  const navigate = useNavigate();

  return (
    <div id="lexilensai-header">
      <div className="app__headerLexiLensAI app__wrapper section__padding" style={{ gap: '4rem' }}>

        {/* LEFT IMAGE / LOGO EMBLEM */}
        <div className="app__wrapper_img">
          <div className="lexiLensImage">
            <img src={images.lexilensAIIcon2 || images.lexilensAIIcon2} alt="lexiLensAIIcon" />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="app__wrapper_info">

          <SubHeading title="Runtime Intelligence and Observability for Enterprise AI Agents" />

          <div className="lexiLensLogo">
            <FontAwesomeIcon className="lexiLensIcon" icon={faDiagramProject} />
            <h1 className="app__header-h1">LexiLensAI</h1>
          </div>
          <div className="lexilensai-points">
            <p>
              • <strong>Session Intelligence:</strong>
              Reconstruct long-running agent sessions,
              context transitions, workflow replay,
              and audit trails.
            </p>

            <p>
              • <strong>Runtime Guardrails:</strong>
              Detect and safe-halt recursive agent loops,
              runaway tool calls, and abnormal token
              escalation before cloud costs spiral.
            </p>

            <p>
              • <strong>Cost & Performance Intelligence:</strong>
              Correlate latency, token consumption, execution paths,
              and model-routing decisions.
            </p>
          </div>
          {/*
          <div className="lexilensai-points">
            <p>• <strong>Distributed Graph Tracing:</strong> Track async parent-child agent workflows and tool invocation lifecycles natively via OpenTelemetry.</p>
            <p>• <strong>Full-Stack Hardware Profiling:</strong> Pinpoint latency anomalies by correlating agent intent with active KV cache pressure and adapter overhead.</p>
            <p>• <strong>Financial Circuit Breakers:</strong> Deploy active runtime guardrails that detect and safe-halt recursive, token-hemorrhaging agent loops.</p>
          </div>
          */}

          <div className="app__header_buttons">
            <div
              className="exploreTrack"
              onClick={() => navigate('/lexilensai')}
              style={{ cursor: 'pointer' }}
            >
              <div>Explore Runtime Intelligence</div>
              <FontAwesomeIcon className="angleRightLogo" icon={faAngleDoubleRight} />
            </div>

            <FontAwesomeIcon
              onClick={() => {
                navigate('/');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="angleUpLogo"
              icon={faAngleDoubleUp}
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default LexiLensAIHeader;
